module.exports = __webpack_public_path__ + "img/rank3.c88c6cfc.png";